/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import GenderFilter from '../../../../../pages/SearchPage/Filters/GenderFilter';
import UtrFilter from '../../../../../pages/SearchPage/Filters/UtrFilter';
import ClubMemberTypeFilter from '../../../../../pages/SearchPage/Filters/ClubMemberTypeFilter';

import styles from '../../../../../pages/ClubProfiles/club.scss';
import searchStyles from '../../../../../pages/SearchPage/search.scss';
import SportTypeFilter from '../../../../../pages/SearchPage/Filters/SportTypeFilter';
import LocationFilter from '../../../../../pages/SearchPage/Filters/LocationFilter';
import { clearFilters, updateFiltersApplied } from '../../../../../actions/search-actions';
import RequestLocation from '../../../../hocs/RequestLocation';
import { gtag } from '../../../../Analytics/gtag';

const _ = { debounce };

class MembersFilters extends Component {
    constructor(props) {
        super(props);
        this.membersListFilter = React.createRef();

        this.state = {
            filters: {},
            filterModal: '',
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setQuery = this.setQuery.bind(this);
        this.updateQueryFilter = _.debounce(this.updateQueryFilter.bind(this), 300);
        this.resetQuery = this.resetQuery.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.clearLocationFilters = this.clearLocationFilters.bind(this);
        this.handleGenderClick = this.handleGenderClick.bind(this);
        this.handleMemberTypeClick = this.handleMemberTypeClick.bind(this);
        this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
        this.handleLocationFilterSubmit = this.handleLocationFilterSubmit.bind(this);
        this.handleSportTypesFilter = this.handleSportTypesFilter.bind(this);
        this.handleSportTypesFilterUpdate = this.handleSportTypesFilterUpdate.bind(this);
        this.undoFilterChange = this.undoFilterChange.bind(this);
        this.handleUTRChange = this.handleUTRChange.bind(this);
        this.handleUtrTypeClick = this.handleUtrTypeClick.bind(this);
        this.handleUtrTeamTypeClick = this.handleUtrTeamTypeClick.bind(this);
        this.handleUtrReliabilityClick = this.handleUtrReliabilityClick.bind(this);
        this.handleFilterUpdate = this.handleFilterUpdate.bind(this);
        this.closeModals = this.closeModals.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.applyLocationFilter = this.applyLocationFilter.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleCurrentLocationClick = this.handleCurrentLocationClick.bind(this);
        this.onLocationRecieved = this.onLocationRecieved.bind(this);
        this.handleDistanceChange = this.handleDistanceChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.refs = {};
    }

    componentDidMount() {
        const sportTypes = this.props.auth?.user ? {
            tennis: this.props?.auth?.feedPreferences?.showTennisContent,
            pickleball: this.props?.auth?.feedPreferences?.showPickleballContent,

        }
            : {
                tennis: true,
                pickleball: true,
            };

        document.addEventListener('mousedown', this.handleClickOutside);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                sportTypes,
            },
            filterModal: '',
        }), () => {
            this.props.setFilters(this.state.filters);
        });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    onLocationRecieved(location) {
        const filterInputs = this.props.search.filterInputs || {};
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                ...this.props.search.geocoded,
                location: location.location,
                distance: filterInputs.distance || '50mi',
                locationInputValue: location.location || '',
                locationCountryName: '',
                locationStateName: '',

            },
            filterModal: '',
        }), () => {
            this.props.setFilters(this.state.filters);
        });
        this.props.changeFilterInputs({
            ...this.props.search.geocoded,
            location: location.location,
            distance: filterInputs.distance || '50mi',
            locationInputValue: location.location || '',
            locationCountryName: '',
            locationStateName: '',
        });
    }

    setQuery(e) {
        console.log('setQuery', e);
        const query = e.target.value;
        this.setState(prevState => {
            const filters = {
                ...prevState.filters,
                query,
            };
            this.updateQueryFilter(filters);
            // this.searchClubMembers(filters);
            return { filters };
        });
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    updateQueryFilter(filters) {
        this.props.setFilters(filters);
    }

    resetQuery() {
        let filters;
        this.setState(prevState => {
            filters = {
                ...prevState.filters,
                query: '',
            };
            this.props.setFilters(filters);
            return { filters };
        });
    }

    handleFilterClick(type) {
        this.setState(prevState => {
            const filterModal = prevState.filterModal === type ? '' : type;
            return {
                filterModal,
            };
        });
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            if (!event.target.classList.contains('menu-item')) { // menu item click not working when the bottom code is called, hackish way to avoid calling if menu item clicked
                this.undoFilterChange();
                this.setState({
                    filterModal: '',
                });
            }
        }
    }

    undoFilterChange() {
        // reset (unapplied) filter changes from parent scope
        this.setState({
            filters: this.props.filters,
        });
    }

    // Gender filter modal
    handleGenderClick({ gender }) {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                gender,
            },
            filterModal: '',
        }), () => {
            // automatically pass filter setting to parent scope
            this.props.setFilters(this.state.filters);
            // this.searchClubMembers(this.state.filters);
        });
    }

    // Member type filter modal
    handleMemberTypeClick(clubMemberTypeId) {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                clubMemberTypeId,
            },
            filterModal: '',
        }), () => {
            // automatically pass filter setting to parent scope
            this.props.setFilters(this.state.filters);
            // this.searchClubMembers(this.state.filters);
        });
    }

    handleUTRChange(utr) {
        console.log('utr', utr);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                utrMin: utr[0],
                utrMax: utr[1],
            },
        }));
    }

    handleUtrTypeClick(utrType) {
        console.log('utrType', utrType);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                utrType,
            },
        }));
    }

    handleUtrTeamTypeClick(utrTeamType) {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });
        console.log('utrTeamType', utrTeamType);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                utrTeamType,
            },
        }));
    }

    handleUtrReliabilityClick(utrReliability) {
        console.log('utrReliability', utrReliability);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                utrReliability,
            },
        }));
    }

    handleFilterSubmit() {
        // manually pass filter setting to parent scope
        this.props.setFilters(this.state.filters);
        // this.searchClubMembers(this.state.filters);
        this.setState({
            filterModal: '',
        });
    }

    handleLocationFilterSubmit() {
        gtag('search-filter', {
            category: 'Search Filter',
            context: `Filter apply - ${JSON.stringify(this.props.search.filters)}`,
            location: 'Search Results CTA',
        });
        this.props.updateFiltersApplied(true);
        this.props.setFilters(this.state.filters);

        this.setState({
            filterModal: '',
        });
    }

    handleSportTypesFilter() {
        this.props.updateFiltersApplied(true);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                sportTypes: this.props.search.filterInputs.sportTypes,
            },
            filterModal: '',
        }), () => {
            this.props.setFilters(this.state.filters);
        });
    }

    handleFilterUpdate(props, update) {
        // only updates filter input field values, input field values have no effect on filter state, these changes don't get submitted, users have to click the apply button first
        // Filter input state is stored in 'filterInputs'
        if (!update || update === 'filterInput') {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    ...props,
                },
            }));
            this.props.changeFilterInputs(props);
        }
    }

    handleSportTypesFilterUpdate(props) {
        this.props.changeFilterInputs(props);
    }

    applyLocationFilter() {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });
        const filters = this.props.search.filterInputs || {};
        const { locationInputValue } = filters;
        if (!((filters.location && filters.lat && filters.lng && filters.distance) || (filters.locationCountryName || filters.locationStateName))) {
            geocodeByAddress(locationInputValue)
                .then(async (results) => {
                    const latLng = await getLatLng(results[0]);
                    return { results, latLng };
                })
                .then(({ results, latLng }) => {
                    console.log('results', results, 'latLng', latLng);
                    if (results[0].types[0] === 'country') {
                        this.setState(prevState => ({
                            filters: {
                                ...prevState.filters,
                                locationCountryName: results[0].address_components[0].long_name,
                                locationStateName: '',
                                distance: filters.distance || '50mi',
                                location: '',
                                locationInputValue: locationInputValue || '',
                                lat: null,
                                lng: null,
                            },
                            filterModal: '',
                        }), () => {
                            this.handleLocationFilterSubmit();
                        });
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[0].long_name,
                            locationStateName: '',
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: locationInputValue || '',
                            lat: null,
                            lng: null,
                        });
                    } else if (results[0].types[0] === 'administrative_area_level_1') {
                        this.setState(prevState => ({
                            filters: {
                                ...prevState.filters,
                                locationCountryName: results[0].address_components[1].long_name,
                                locationStateName: results[0].address_components[0].long_name,
                                distance: filters.distance || '50mi',
                                location: '',
                                locationInputValue: locationInputValue || '',
                                lat: null,
                                lng: null,
                            },
                            filterModal: '',
                        }), () => {
                            this.handleLocationFilterSubmit();
                        });
                        this.props.changeFilterInputs({
                            locationCountryName: results[0].address_components[1].long_name,
                            locationStateName: results[0].address_components[0].long_name,
                            distance: filters.distance || '50mi',
                            location: '',
                            locationInputValue: locationInputValue || '',
                            lat: null,
                            lng: null,
                        });
                    } else {
                        this.setState(prevState => ({
                            filters: {
                                ...prevState.filters,
                                lat: latLng.lat,
                                lng: latLng.lng,
                                location: locationInputValue,
                                distance: filters.distance || '50mi',
                                locationInputValue: locationInputValue || '',
                                locationCountryName: '',
                                locationStateName: '',
                            },
                            filterModal: '',
                        }), () => {
                            this.handleLocationFilterSubmit();
                        });
                        this.props.changeFilterInputs({
                            lat: latLng.lat,
                            lng: latLng.lng,
                            location: locationInputValue,
                            distance: filters.distance || '50mi',
                            locationInputValue: locationInputValue || '',
                            locationCountryName: '',
                            locationStateName: '',
                        });
                    }
                    this.handleLocationFilterSubmit();
                })
                .catch(error => console.error('geocodeByAddress error', error));
        } else {
            this.handleLocationFilterSubmit();
        }
    }

    handleLocationChange(locationInputValue) {
        console.log('handleLocationChange', locationInputValue);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                locationInputValue,
                locationCountryName: '',
                locationStateName: '',
                location: '',
                lat: null,
                lng: null,

            },
        }));
        this.props.changeFilterInputs({
            locationInputValue,
            locationCountryName: '',
            locationStateName: '',
            location: '',
            lat: null,
            lng: null,
        });
    }

    generateFilterObject(result, latLng, location) {
        const commonFilters = {
            distance: this.props.search.filterInputs?.distance || '50mi',
            location: '',
            locationInputValue: location !== undefined && location !== null ? location : '',
            lat: null,
            lng: null,
        };

        if (result.types[0] === 'country') {
            return {
                ...commonFilters,
                locationCountryName: result.address_components[0].long_name,
                locationStateName: '',
            };
        }
        if (result.types[0] === 'administrative_area_level_1') {
            return {
                ...commonFilters,
                locationCountryName: result.address_components[1].long_name,
                locationStateName: result.address_components[0].long_name,
            };
        }
        return {
            ...commonFilters,
            locationCountryName: '',
            locationStateName: '',
            lat: latLng.lat,
            lng: latLng.lng,
            location,
        };
    }

    handleLocationSelect(location) {
        console.log('handleLocationSelect', location);
        const filters = this.props.search.filterInputs || {};
        if (location) {
            geocodeByAddress(location)
                .then(async (results) => {
                    const latLng = await getLatLng(results[0]);
                    return { results, latLng };
                })
                .then(({ results, latLng }) => {
                    const updatedFilters = this.generateFilterObject(results[0], latLng, location);

                    this.setState(prevState => ({
                        filters: {
                            ...prevState.filters,
                            ...updatedFilters,
                        },
                    }));

                    this.props.changeFilterInputs({
                        ...updatedFilters,
                    });
                });
        }
    }

    handleCurrentLocationClick() {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });
        this.props.setFilters(this.state.filters);
        if (this.props.fetchCurrentLocation) {
            this.props.fetchCurrentLocation(this.onLocationRecieved);
        }
    }

    handleDistanceChange(distance) {
        console.log('handleDistanceChange', distance);
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                distance: `${distance}mi`,

            },
        }));
        this.props.changeFilterInputs({
            distance: `${distance}mi`,
        });
    }

    clearFilters(type, reSearch) {
        console.log('clearFilters', type);
        this.props.clearSorting();
        this.setState(prevState => ({
            filters: {
                query: '',
                sportTypes: prevState.filters.sportTypes,
            },
            filterModal: '',
        }));
        this.props.clearFilters(type);
        this.props.setFilters({
            clearSort: {
                field: 'firstName',
                order: 'asc',
            },
            query: '',
            sportTypes: this.state.filters.sportTypes,
        });
    }

    clearLocationFilters(type) {
        this.props.changeFilterInputs({ sportTypes: this.state.filters.sportTypes });
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                lat: null,
                lng: null,
                location: '',
                distance: '50mi',
                locationInputValue: '',
                locationCountryName: '',
                locationStateName: '',
            },
            filterModal: '',
        }));
        this.props.clearFilters(type);
        this.props.setFilters(this.state.filters);
    }

    closeModals() {
        this.setState({
            filterModal: '',
        });
    }

    render() {
        const {
            filters,
            filterModal,
        } = this.state;

        const {
            clearFilters,
            auth,
            mobileOnly,
            desktopOnly,

        } = this.props;

        const filterInputs = {};
        const searchTypes = {};
        searchTypes.sportTypes = this.props.coreUI.types?.tms?.sportTypes;
        const filterType = this.props.search.filters?.type || '';
        const hasUtrFilters = (filters.utrMin > 1 || filters.utrMax < 16) && (filters.utrType || filters.utrTeamType);
        const hasSportTypes = filters?.sportTypes?.tennis || filters?.sportTypes?.pickleball;
        const hasFilters = filters.query || filters.gender || hasUtrFilters;
        const hasAdditionalFilters = filters.utrReliability || filters.clubMemberTypeId || hasSportTypes;
        const activeFilters = filters && (hasFilters || hasAdditionalFilters);
        const commonFilterProps = {
            filters,
            state: this.state,
            searchTypes,
            filterType,
            auth,
            clearFilters,
            filterInputs,
            handleFilterClick: this.handleFilterClick,
            filterModal: this.state.filterModal,
            closeModals: this.closeModals,
            handleFilterSubmit: this.handleFilterSubmit,
            mobileOnly,
            desktopOnly,
        };

        return (
            <div>
                <div className={`${styles.titleContainer} ${styles.filterContainer} row bt bb mt0 pt16 mb16`} ref={this.setWrapperRef}>
                    <div className={`col-12 col-md-4`}>
                        <div className={`${styles.filterWrapper}`}>
                            <i className={`uts uts-search`} />
                            <input
                                type="text"
                                placeholder="Search players"
                                className="form-control form-control-sm search"
                                ref={this.query}
                                value={filters.query}
                                onChange={this.setQuery}
                                data-testid="club-members.search-input"
                            />
                            <i className={`uts uts-close ${filters.query ? 'd-block' : 'd-none'}`} onClick={this.resetQuery} data-testid="club-members.search-clear-btn" />
                        </div>
                    </div>
                    <div className={`col-12 col-md-8`}>
                        <div className={`${searchStyles.searchFilters} np nb`}>
                            <SportTypeFilter
                                searchTypes={searchTypes}
                                filterType={filterType}
                                auth={this.props.auth}
                                clearFilters={this.clearFilters}
                                filterInputs={this.props.search.filterInputs}
                                filters={this.props.search.filters}
                                filterModal={this.state.filterModal}
                                handleFilterSubmit={this.handleSportTypesFilter}
                                handleFilterUpdate={this.handleSportTypesFilterUpdate}
                                handleFilterClick={this.handleFilterClick}
                                applyLocationFilter={this.applyLocationFilter}
                                closeModals={this.closeModals}
                                data-testid="club-members.filter.sport-type"
                            />
                            <GenderFilter
                                {...commonFilterProps}
                                handleFilterUpdate={this.handleGenderClick}
                                data-testid="club-members.filter.gender"
                            />
                            <UtrFilter
                                {...commonFilterProps}
                                filters={this.props.search.filters}
                                filterInputs={this.props.search.filterInputs}
                                handleUTRChange={this.handleUTRChange}
                                handleUtrTypeClick={this.handleUtrTypeClick}
                                handleUtrTeamTypeClick={this.handleUtrTeamTypeClick}
                                handleUtrReliabilityClick={this.handleUtrReliabilityClick}
                                handleFilterUpdate={this.handleFilterUpdate}
                                showExpandedUtrFilter={true}
                                isClubFilter={true}
                                data-testid="club-members.filter.utr"
                            />
                            <LocationFilter
                                clearFilters={this.clearLocationFilters}
                                filterInputs={this.props.search.filterInputs}
                                handleFilterClick={this.handleFilterClick}
                                closeModals={this.closeModals}
                                mobileOnly={mobileOnly}
                                desktopOnly={desktopOnly}
                                filters={this.props.search.filters}
                                filterModal={this.state.filterModal}
                                geocoded={this.props.search.geocoded}
                                handleFilterSubmit={this.handleLocationFilterSubmit}
                                applyLocationFilter={this.applyLocationFilter}
                                handleLocationChange={this.handleLocationChange}
                                handleLocationSelect={this.handleLocationSelect}
                                handleCurrentLocationClick={this.handleCurrentLocationClick}
                                handleDistanceChange={this.handleDistanceChange}
                                data-testid="club-members.filter.location"
                            />
                            <ClubMemberTypeFilter
                                {...commonFilterProps}
                                filterInputs={filters}
                                handleMemberTypeClick={this.handleMemberTypeClick}
                                data-testid="club-members.filter.member-type"
                            />
                            {activeFilters && <u className="clickable text-teal text-small text-normal no-wrap" onClick={this.clearFilters}>reset filters</u>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ coreUI, search, auth }) {
    return { coreUI, search, auth };
}

function mapDispatchToProps(dispatch) {
    return {
        updateFiltersApplied: (reSearch) => {
            dispatch(updateFiltersApplied(reSearch, 'clubs'));
        },
        clearFilters: (type, reSearch) => {
            dispatch(clearFilters(type, reSearch));
        },
    };
}
MembersFilters.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    search: PropTypes.instanceOf(Object),
    coreUI: PropTypes.instanceOf(Object),
    setFilters: PropTypes.func,
    updateFiltersApplied: PropTypes.func,
    clearFilters: PropTypes.func,
    changeFilterInputs: PropTypes.func,
    fetchCurrentLocation: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
};

MembersFilters.defaultProps = {
    setFilters: () => { },
    updateFiltersApplied: () => { },
    changeFilterInputs: () => { },
    fetchCurrentLocation: () => { },
    clearFilters: () => { },
    search: null,
    mobileOnly: false,
    desktopOnly: false,
    coreUI: false,
};
export default RequestLocation(connect(mapStateToProps, mapDispatchToProps)(MembersFilters));
